
import { userActionStore, userToolStore } from '@/store';
import _ from 'lodash';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class TemplateCheckout extends Vue {
  get checkoutTool() {
    return (
      _.find(userToolStore.currentUserTools, { tool_id: 9 }) || {
        allow_view: false,
        allow_edit: false,
        allow_delete: false,
        allow_create: false,
      }
    );
  }

  get editarQualquerCheckoutAction() {
    return userActionStore.EditarQualquerCheckout;
  }
}
